import WrapRootElement from "./src/WrapRootElement";

export const wrapRootElement = WrapRootElement;
